export const productionCN = {
  'Btn.text1': '开始探索',
  'Celelens.Text1': '0代码',
  'Celelens.Text15': '自动分析和注释',
  'Celelens.Text2': '让单细胞数据更有力量',
  'Celelens.Text16': '',
  'Celelens.Text3': '你的矩阵 或 公共数据',
  'Celelens.Text4': '轻松上手',
  'Celelens.Text17': '',
  'Celelens.Text18': '',
  'Celelens.Text5': '点一点',
  'Celelens.Text6': '即刻完成',
  'Celelens.Text7': '全自动分析流程',
  'Celelens.Text8': '参数可调、可复现',
  'Celelens.Text9': '推荐默认参数',
  'Celelens.Text10': '或按需自定义',
  'Celelens.Text11': '数据整合 · 细胞注释 · 图形可视化',
  'Celelens.Text12': 'SynEcoSys参考体系',
  'Celelens.Text13': '确保结果精准可靠',
  'Celelens.Text14': '自定义标签随心编辑',

  'SynEcoSys.Text1': '从单细胞多组学走向精准医疗',
  'SynEcoSys.Text26': '',
  'SynEcoSys.Text2': 'SynEcoSys不只是一个普通的数据库',
  'SynEcoSys.Text3': '为什么选择 SynEcoSys？',
  'SynEcoSys.Text4': '精准可靠',
  'SynEcoSys.Text5': '精心筛选的单细胞数据，附带详尽的疾病与治疗元数据。',
  'SynEcoSys.Text6': '标准一致',
  'SynEcoSys.Text7': '标准化数据归一化与注释体系，支持跨研究数据集的直接比对。',
  'SynEcoSys.Text8': '便捷易用',
  'SynEcoSys.Text9': '自动化且可定制的数据分析流程及图形化操作界面。',
  'SynEcoSys.Text10': '独家参考',
  'SynEcoSys.Text11': '独家细胞类型知识库远超公共资源，提供具备证据来源、可灵活排序的标记物，助力实现更精准的细胞注释。',
  'SynEcoSys.Text12': '全面覆盖',
  'SynEcoSys.Text13': '涵盖多物种、主要组织与疾病类型的数据集合，并支持智能筛选功能。',
  'SynEcoSys.Text14': '出版就绪',
  'SynEcoSys.Text15': '精美而灵活可调的数据可视化图表，满足高质量出版需求。',
  'SynEcoSys.Text16': '应用',
  'SynEcoSys.Text17': '药物靶点识别',
  'SynEcoSys.Text18': '跨队列',

  'SynEcoSys.Text19': '标志物发现',
  'SynEcoSys.Text20': '疾病分期/亚型',

  'SynEcoSys.Text21': '比对验证',
  'SynEcoSys.Text22': '针对特定领域内已发表成果进行基准化对标分析',

  'SynEcoSys.Text23': '数据整合分析',

  'SynEcoSys.Text24': '标志物验证',
  'SynEcoSys.Text25': '基于公开数据集',


};

export const productionUS = {
  'Btn.text1': 'Get Started',
  'Celelens.Text1': 'Unlock the Power of',
  'Celelens.Text15': 'Single Cell Multi-omics',
  'Celelens.Text2': 'with code-free, automated analysis',
  'Celelens.Text16': 'and annotation',
  'Celelens.Text3': 'YOUR DATA/PUBLIC DATASETS',
  'Celelens.Text4': 'Sit back,',
  'Celelens.Text17': 'relax,',
  'Celelens.Text18': 'and',
  'Celelens.Text5': 'click',
  'Celelens.Text6': '',
  'Celelens.Text7': 'Automated pipeline',
  'Celelens.Text8': 'Adjustable, replicable parameters: ',
  'Celelens.Text9': 'Recommended default',
  'Celelens.Text10': 'Or at your preference',
  'Celelens.Text11': 'INTEGRATED & ANNOTATED & VISUALIZED',
  'Celelens.Text12': 'SynEcoSys reference guarantees ',
  'Celelens.Text13': 'accuracy and precision',
  'Celelens.Text14': 'Customize labels as you wish',

  'SynEcoSys.Text1': 'From Single-Cell Multi-Omics',
  'SynEcoSys.Text26': 'to Precision Medicine',
  'SynEcoSys.Text2': 'SynEcoSys is not just another average online database',
  'SynEcoSys.Text3': 'Why choose SynEcoSys?',
  'SynEcoSys.Text4': 'Accurate',
  'SynEcoSys.Text5': 'Carefully curated single-cell data with metadata on disease and treatment infomation',
  'SynEcoSys.Text6': 'Consistent',
  'SynEcoSys.Text7': 'Standardized normalization and annotation enabling comparing datasets from different studies',
  'SynEcoSys.Text8': 'Ease-of-use',
  'SynEcoSys.Text9': 'Automated and customizable data analysis with graphical interfaces',
  'SynEcoSys.Text10': 'Exclusive',
  'SynEcoSys.Text11': 'A proprietary cell type knowledge base far superior to public resources, providing evidence-based, sortable markers to empower precise cell annotation',
  'SynEcoSys.Text12': 'Comprehensive',
  'SynEcoSys.Text13': 'Datasets covering multiple species and major tissue and diseases with filtering function ',
  'SynEcoSys.Text14': 'Publication-ready',
  'SynEcoSys.Text15': 'Elegant and customizable data visualization',

  'SynEcoSys.Text16': 'Applications',
  'SynEcoSys.Text17': 'Drug Target Identification',
  'SynEcoSys.Text18': 'across cohorts',

  'SynEcoSys.Text19': 'Biomarker discovery',
  'SynEcoSys.Text20': 'for disease stages/subtypes',

  'SynEcoSys.Text21': 'Benchmarking',
  'SynEcoSys.Text22': 'against previous publications in a given area',

  'SynEcoSys.Text23': 'Meta-analysis',
  
  'SynEcoSys.Text24': 'Biomaker validation',
  'SynEcoSys.Text25': 'using published datasets',
};